import React from "react";

import "./subscribe.css"
import Banner9 from "../../assets/images/banner-9.png";
import Icon1 from "../../assets/images/icon-1.svg";
import Icon2 from "../../assets/images/icon-2.svg";
import Icon3 from "../../assets/images/icon-3.svg";
import Icon4 from "../../assets/images/icon-4.svg";
import Icon5 from "../../assets/images/icon-5.svg"; 


function Subscribe(){
    return(
        <>
        <section className="newsletter relative mt_30 bg_white_g mb_15">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                    <div class="position-relative newsletter-inner">
                            <div class="newsletter-content">
                                <h2 class="mb_20 font-heading">
                                    Stay home &amp; get your daily  <br />
                                    needs from our shop
                                </h2>
                                <p class="mb_40">Start You'r Daily Shopping with <span class="text-brand">FMBGK</span></p>
                                 <button class="btn" type="submit" className="subscribe_btn">Buy Now</button>
                               </div>
                            <img src={Banner9} alt="newsletter" />
                        </div>
                    </div>
                </div>
            </div>
            </section>

            <section className="featured section-padding pt_10">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="grid_5 gap_10">
                    <div className="">
                        <div className="banner-left-icon d-flex align-items-center">
                            <div className="banner-icon">
                                <img src={Icon1} alt="" />
                            </div>
                            <div className="banner-text">
                                <h3 className="icon-box-title">Best prices &amp; offers</h3>
                                <p>Orders $50 or more</p>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="banner-left-icon d-flex align-items-center" >
                            <div className="banner-icon">
                                <img src={Icon2} alt="" />
                            </div>
                            <div className="banner-text">
                                <h3 className="icon-box-title">Free delivery</h3>
                                <p>24/7 amazing services</p>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="banner-left-icon d-flex align-items-center"  >
                            <div className="banner-icon">
                                <img src={Icon3} alt="" />
                            </div>
                            <div className="banner-text">
                                <h3 className="icon-box-title">Great daily deal</h3>
                                <p>When you sign up</p>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="banner-left-icon d-flex align-items-center " >
                            <div className="banner-icon">
                                <img src={Icon4} alt="" />
                            </div>
                            <div className="banner-text">
                                <h3 className="icon-box-title">Wide assortment</h3>
                                <p>Mega Discounts</p>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="banner-left-icon d-flex align-items-center " >
                            <div className="banner-icon">
                                <img src={Icon5} alt="" />
                            </div>
                            <div className="banner-text">
                                <h3 className="icon-box-title">Easy returns</h3>
                                <p>Within 30 days</p>
                            </div>
                        </div>
                    </div>
                     
                    </div>
                </div>
            </div>
            </div>
        </section>

        </>
    )
}
export default Subscribe;
